import { handleApiCall } from "../Helpers/HandleApi";
import {getConfigVersion} from "../../Constants/config"
export const _getLocalisationConfigLanguage = (langURL: string) => {
  return handleApiCall({
    url: langURL,
    method: "get"
  },
  );
};

export const _getSupportedLanguage = (dataObj: {}) => {
  return handleApiCall({
    url: getConfigVersion,
    method: "post",
    dataObj: dataObj,
    headers:{"Content-Type": "application/x-www-form-urlencoded"},
    requestBody: { type: Object, encryption: false,queryString:true },
  },
  true
  );
};